import React from 'react';
export function Card({
  children,
  className = '',
  ...props
}: {
  children: React.ReactNode;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`bg-white rounded-2xl border border-slate-200/60 shadow-sm overflow-hidden ${className}`} {...props} data-id="element-1569">
      {children}
    </div>;
}
export function CardHeader({
  title,
  subtitle,
  action,
  icon
}: {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  icon?: React.ReactNode;
}) {
  return <div className="px-6 py-4 border-b border-slate-100 bg-slate-50/50 flex justify-between items-center" data-id="element-1570">
      <div className="flex items-center gap-3" data-id="element-1571">
        {icon && <div data-id="element-1572">{icon}</div>}
        <div data-id="element-1573">
          <h3 className="text-[15px] font-semibold text-slate-900" data-id="element-1574">{title}</h3>
          {subtitle && <p className="text-[13px] text-slate-500 mt-0.5" data-id="element-1575">{subtitle}</p>}
        </div>
      </div>
      {action && <div data-id="element-1576">{action}</div>}
    </div>;
}
export function CardContent({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const hasPadding = /\bp-\d|px-|py-/.test(className);
  return <div className={`${hasPadding ? '' : 'p-6'} ${className}`} data-id="element-1577">{children}</div>;
}